<section class="balance-breakdown">
  <div class="breakdown-header">
    <h3 class="breakdown-title">Balance breakdown</h3>

    @if (showIncludeMerchants) {
      <label class="include-merchants" [class.disabled]="isLoading">
        <span class="include-merchants-label">Include merchants</span>
        <input
          type="checkbox"
          [checked]="includeMerchants"
          [disabled]="isLoading"
          (change)="onIncludeMerchantsToggle($event.target.checked)"
        />
        <span class="toggle-track"><span class="toggle-thumb"></span></span>
      </label>
    }
  </div>

  @if (isLoading || metadata.isLoading()) {
    <div class="asset-grid" aria-busy="true">
      @for (_ of skeletonCards; track $index) {
        <div class="asset-skeleton">
          <ngx-skeleton-loader
            aria-hidden="true"
            appearance="line"
            [theme]="{ width: '29px', height: '29px', borderRadius: '50%', margin: '0' }"
          />
          <ngx-skeleton-loader
            aria-hidden="true"
            appearance="line"
            [theme]="{ width: '48px', height: '16px', borderRadius: '6px', margin: '0' }"
          />
          <ngx-skeleton-loader
            ariaLabel="Loading balances"
            [attr.aria-hidden]="!$first || null"
            appearance="line"
            [theme]="{ width: '110px', height: '18px', borderRadius: '6px', margin: '0' }"
          />
        </div>
      }
    </div>
  } @else if (error || metadata.error()) {
    <app-empty-state icon="error_outline" title="Couldn't load balances" [subtitle]="error || metadata.error()" />
  } @else if (assets().length) {
    <div class="asset-grid">
      @for (asset of assets(); track asset.asset) {
        <app-asset-card [asset]="asset" />
      }
    </div>
  } @else {
    <app-empty-state title="No balances yet" subtitle="Balances will appear here once funds are received." />
  }
</section>
